























import privacy from '@/assets/agreements/privacy.html';
import RichTextDisplay from '@/components/common/RichTextDisplay.vue';
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({
  components: {
    RichTextDisplay,
  },
})
export default class Privacy extends Vue {
  public privacyText: string = privacy;
}
